function initIllustrationAndText() {
	const blocks = document.querySelectorAll("[data-illustration-and-text]");

	blocks.forEach((block) => {
		const toggle = block.querySelector(".illustration-and-text__toggle");
		const label = block.querySelector(
			".illustration-and-text__toggle-label",
		);
		const texts = block.querySelectorAll(".illustration-and-text__text");
		const paragraphCount = Math.max(
			...Array.from(texts).map(
				(text) => text.querySelectorAll("p").length,
			),
		);

		if (!toggle || !label || paragraphCount <= 2) {
			if (toggle) toggle.remove();
			return;
		}

		toggle.addEventListener("click", () => {
			const isExpanded = block.classList.toggle("is-expanded");

			toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
			label.textContent = isExpanded ? "Show less" : "Read more";
		});
	});
}

initIllustrationAndText();
